// extracted by mini-css-extract-plugin
module.exports = {"NoData":"NoDataComponent_NoData__wqbkj","MainContainer":"NoDataComponent_MainContainer__1h32n"};